var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderContent',{attrs:{"header":"คำสั่งซื้อ","img_header":_vm.header_image,"link_back":"content"}}),_c('MenuContentPurchase'),_c('ContentOrderList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }